import { render, staticRenderFns } from "./FailedSettlement.vue?vue&type=template&id=5ed411e0&"
import script from "./FailedSettlement.vue?vue&type=script&lang=js&"
export * from "./FailedSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports